import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _omit from "lodash/omit";
import _compact from "lodash/compact";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Fragment, useState, useEffect } from 'react';
import classNames from 'classnames';
import Help from '@nerdwallet/react-icon/nerdwallet-ui/Help';
import Type from '@nerdwallet/react-typography';
import { useId } from '@nerdwallet/react-accessibility';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import { usePopoverState, Popover, PopoverDisclosure, usePopoverArrow } from 'reakit/Popover';
import useElementInteraction from './useElementInteraction';
import style from './tooltip.module.less';

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      className = _ref.className,
      content = _ref.content,
      placement = _ref.placement,
      initiallyOpen = _ref.initiallyOpen,
      label = _ref.label,
      dangerouslyForceFocusStyling = _ref.dangerouslyForceFocusStyling,
      idProp = _ref.id,
      onChangeContentVisibility = _ref.onChangeContentVisibility,
      analytics = _ref.analytics,
      popperOptions = _ref.popperOptions,
      htmlTitle = _ref.title,
      htmlOnClick = _ref.onClick,
      htmlOnFocus = _ref.onFocus,
      htmlOnBlur = _ref.onBlur,
      htmlProps = _objectWithoutProperties(_ref, ["children", "className", "content", "placement", "initiallyOpen", "label", "dangerouslyForceFocusStyling", "id", "onChangeContentVisibility", "analytics", "popperOptions", "title", "onClick", "onFocus", "onBlur"]);

  useDeprecatedPropsWarning({
    component: 'Tooltip',
    deprecatedProps: [{
      deprecated: 'popperOptions',
      migration: 'Custom icons are no longer recommended for use in designs.',
      version: '1.3.0'
    }],
    props: {
      popperOptions: popperOptions
    }
  });
  var id = useId(idProp);
  var isTextTooltip = typeof content === 'string';
  var state = usePopoverState({
    baseId: id,
    placement: placement,
    // animate: true // TODO: set this to true if using css animations/transitions
    visible: initiallyOpen
  });
  var arrowState = usePopoverArrow(state);
  var visible = state.visible,
      animating = state.animating; // determine if content is visible (i.e. potential animations are completed)

  var contentVisible = visible ? !animating : animating; // call visibility changed handler when content visibility changes

  var _useState = useState(contentVisible),
      _useState2 = _slicedToArray(_useState, 2),
      prevContentIsVisible = _useState2[0],
      setPrevContentIsVisible = _useState2[1];

  useEffect(function () {
    if (contentVisible === prevContentIsVisible) return undefined;
    setPrevContentIsVisible(contentVisible);
    onChangeContentVisibility(contentVisible);
    return undefined;
  }, [contentVisible, prevContentIsVisible, onChangeContentVisibility]); // build handlers for firing bedrock events after interactions

  var elementInteractionForTrigger = useElementInteraction({
    // truthiness of analytics props determines if events are fired
    enable: !!analytics,
    entityName: (analytics === null || analytics === void 0 ? void 0 : analytics.entityName) || _compact([analytics === null || analytics === void 0 ? void 0 : analytics.entityNamePrefix, id]).join('_'),
    // visibility can be delayed by library
    // so using this hook here in tooltip means
    // it needs the reakit visible state and the reakit animating state
    visible: contentVisible,
    // chain event handlers from props if they exist.
    onClick: htmlOnClick,
    onFocus: htmlOnFocus,
    onBlur: htmlOnBlur
  }); // create a title prop for the trigger

  var triggerTitle = htmlTitle || htmlProps['aria-label'];

  if (!triggerTitle && label) {
    triggerTitle = "More information about ".concat(label);
  }

  return /*#__PURE__*/React.createElement(Fragment, null, label && /*#__PURE__*/React.createElement(Type, {
    inline: true,
    className: classNames(style.label)
  }, label), /*#__PURE__*/React.createElement(PopoverDisclosure, _extends({}, state, {
    as: "button",
    type: "button" // specific styles added with className prop
    ,
    className: classNames(style.trigger, className, _defineProperty({}, style['force-focus'], dangerouslyForceFocusStyling)) // event handlers for element interactions

  }, elementInteractionForTrigger, {
    // generated title
    title: triggerTitle
  }), /*#__PURE__*/React.createElement("span", {
    className: style.tappable,
    "aria-hidden": "true"
  }), children), /*#__PURE__*/React.createElement(Popover, _extends({}, state, {
    // use a span instead of a div to prevent `cannont nest <div> inside of <p>` DOM validation errors
    as: "span",
    className: classNames(style.tooltip, _defineProperty({}, style.textTooltip, isTextTooltip)) // tabIndex=0 transfers focus from trigger to popover dialog
    // when it is opened. this allows further tab-navigating
    // into the content of the tooltip (links, buttons, etc...)
    ,
    tabIndex: 0 // first thing screen reader reads, so
    // e.g. "<this was the label prop>, dialog, 4 items..."
    ,
    "aria-label": htmlProps['aria-label'] || htmlTitle || label // reakit sets role of dialog

  }), /*#__PURE__*/React.createElement("span", _extends({}, _omit(arrowState, 'children'), {
    className: classNames(style.arrow, style["arrow-".concat(state.placement)] // top, bottom, right, left
    ) // don't count this in element count of dialog when screen reader is reading
    ,
    "aria-hidden": true
  })), isTextTooltip ? /*#__PURE__*/React.createElement(Type, {
    inline: true
  }, content) : content));
};

Tooltip.defaultProps = {
  className: null,
  label: null,
  placement: 'bottom',
  initiallyOpen: false,
  dangerouslyForceFocusStyling: false,
  children: /*#__PURE__*/React.createElement(Help, null),
  onChangeContentVisibility: function onChangeContentVisibility() {},
  // do not track elementInteractions by default
  analytics: false
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Tooltip.propTypes = {
    /** Optional analytics information (pulled from legacy HelpBubble) */
    analytics: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
      entityName: PropTypes.string,
      entityNamePrefix: PropTypes.string
    })]),

    /** Optional trigger element.  default is <button><Help /><button> */
    children: PropTypes.node,

    /* Applies a CSS classname to the component. */
    className: PropTypes.string,

    /* Content to be shown inside the tooltip. */
    content: PropTypes.node.isRequired,

    /** Optional ID. Set automatically in browser if not provided. */
    id: PropTypes.string,

    /** Optional label next to tooltip trigger */
    label: PropTypes.string,

    /** One of four placement choices, default: bottom */
    placement: PropTypes.oneOf(['bottom', 'top', 'left', 'right']),

    /** If set to true the tooltip will render initially open */
    initiallyOpen: PropTypes.bool,

    /** Force the component to render with its focus styles. */
    dangerouslyForceFocusStyling: PropTypes.bool,

    /** Optional handler for change of visibility for tooltip content.  called with ({ visible: Bool }) */
    onChangeContentVisibility: PropTypes.func,

    /** DEPRECATED: Now NOOP. Options provided to the [`popper.js`](https://github.com/FezVrasta/popper.js) instance. */
    popperOptions: PropTypes.object // eslint-disable-line react/forbid-prop-types

  };
}

Tooltip.displayName = 'Tooltip';
export default Tooltip;
/**
 * HelpBubble is a simple wrapper that never prints the label
 * also, it adds analytics prefix to keep compatibility with legacy @nerdwallet/react-help-bubble
 */

export var HelpBubble = function HelpBubble(_ref2) {
  var analytics = _ref2.analytics,
      children = _ref2.children,
      label = _ref2.label,
      title = _ref2.title,
      props = _objectWithoutProperties(_ref2, ["analytics", "children", "label", "title"]);

  return /*#__PURE__*/React.createElement(Tooltip, _extends({}, props, {
    title: title || label,
    analytics: analytics && _objectSpread({
      entityNamePrefix: 'help_bubble'
    }, analytics)
  }), /*#__PURE__*/React.createElement(Help, null));
};
HelpBubble.propTypes = Tooltip.propTypes;
HelpBubble.defaultProps = Tooltip.defaultProps;